import PropTypes from 'prop-types';
import { useTranslation, useDateFormat } from '@eti/providers';
import { date } from '@eti/utils';
import { css } from '@eti/styles';

const wrapperStyles = (isLastSegmentInBound) => css`
  align-items: center;
  border-bottom: ${isLastSegmentInBound ? 'none' : '1px dotted #cddbe4'};
  display: flex;
  margin: 0.75rem 0;
  padding-bottom: ${isLastSegmentInBound ? '0' : '0.75rem'};
`;

const cityCodesStyles = css`
  display: flex;
  margin-bottom: 0.5rem;

  span:nth-child(2) {
    margin: 0 0.25rem;
  }
`;

const timeWrapperStyles = css`
  display: flex;
`;

const timeStyles = css`
  margin-left: 0.25rem;

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 0.25rem;
  }
`;

const Segment = ({ isLastSegmentInBound, content = {} }) => {
  const { t } = useTranslation();
  const { time } = useDateFormat();

  const {
    isDeparture,
    flightNumber,
    timeOld,
    timeNew,
    originCityCode,
    originCityName,
    destinationCityCode,
    destinationCityName,
  } = content;

  return (
    <div className={wrapperStyles(isLastSegmentInBound)} data-testid="paymentPage-segment-wrapper">
      <ul>
        <li className={cityCodesStyles}>
          <span>{`${originCityCode} ${originCityName} - ${destinationCityCode} ${destinationCityName}`}</span>
        </li>
        <li>{flightNumber}</li>
        <li className={timeWrapperStyles}>
          <span>
            {isDeparture
              ? t('Notification.TripScheduleChange.Departure.Original.Text')
              : t('Notification.TripScheduleChange.Arrival.Original.Text')}
          </span>
          <span className={timeStyles}>{date.format(timeOld, time)} </span>
        </li>
        <li className={timeWrapperStyles}>
          <span>
            {isDeparture
              ? t('Notification.TripScheduleChange.Departure.New.Text')
              : t('Notification.TripScheduleChange.Arrival.New.Text')}
          </span>
          <span className={timeStyles}>
            <strong> {date.format(timeNew, time)} </strong>
          </span>
        </li>
      </ul>
    </div>
  );
};

Segment.propTypes = {
  content: PropTypes.shape({
    destinationCityCode: PropTypes.string,
    destinationCityName: PropTypes.string,
    flightNumber: PropTypes.string,
    isDeparture: PropTypes.bool,
    originCityCode: PropTypes.string,
    originCityName: PropTypes.string,
    timeNew: PropTypes.string,
    timeOld: PropTypes.string,
  }),
  isLastSegmentInBound: PropTypes.bool,
};

export default Segment;
